<ct-button [configuration]="cloneConfiguration"></ct-button>
